import React from "react";

const TableHeader = ({ columns, activeTab, handleTabChange }) => (
  <div style={{ width: "100%", display: "flex", boxSizing: "border-box" }}>
    {columns.map((item) => (
      <div
        key={item.id}
        style={{
          padding: "0.8em 3em",
          borderBottom: activeTab === item.id ? "2px solid #6f42c1" : "none",
          cursor: "pointer",
          fontWeight: "bold",
        }}
        onClick={() => handleTabChange(item.id)}
      >
        {item.value}
      </div>
    ))}
  </div>
);

export default TableHeader;
